import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonList,
  IonItem,
  IonLabel,
  IonText,
  IonInput,
  IonRow,
  IonCol,
  IonImg,
  IonItemDivider,
  IonProgressBar,
  IonToast,
  IonCheckbox,
  IonGrid,
  IonIcon,
  IonModal,
  IonFooter,
  IonButtons,
  IonLoading, IonRefresher, IonRefresherContent
} from '@ionic/react';
import { connect } from 'react-redux'
import HomeActions from '../../actions/HomeActions';
import { getLoginApp, getchek, getLATLNG, getDominio } from '../../utils/functions';
import { baseurl } from '../../constants/constants';

import { logoWhatsapp, eye, eyeOutline, eyeOffOutline, arrowBack, qrCode, mailOpenOutline, globeOutline, callOutline, appsOutline, downloadOutline } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';

import { Printer } from '@bcyesil/capacitor-plugin-printer';
interface IProps {
  get_: any;
  post_: any;
  changeFields: any;
  setData_: any;
}

interface IState {
  check: boolean;
  formErrors: any;
  username: any;
  password: any;
  eye: boolean;
  simpleToast: boolean;
  loading: boolean;
  response: any;
  save_data: any;
  dominio: any;
  lat: any;
  id_dominio_backend: any;
  showInstall: boolean;
}
const lat: any = "";
const long: any = "";
let resizeinit = "";

class Login extends React.Component<IProps, IState> {
  modal: React.RefObject<HTMLIonModalElement>;
  deferredPrompt: any = null;
  constructor(props: any) {
    super(props)
    this.modal = React.createRef<HTMLIonModalElement>();
    this.state = {
      username: props.username,
      password: props.password,
      check: false,
      formErrors: props.formErrors,
      eye: props.eye,
      simpleToast: props.simpleToast,
      loading: props.loading,
      save_data: props.save_data,
      response: props.response,
      dominio: props.dominio,
      lat: props.lat,
      id_dominio_backend: props.id_dominio_backend,
      showInstall: false // nuevo estado para mostrar el botón
    }
    this.handleInstallClick = this.handleInstallClick.bind(this);
  }

  componentDidMount() {
    // --- Lógica de beforeinstallprompt para PWA ---
    this.beforeInstallPromptHandler = (e: any) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.setState({ showInstall: true });
    };
    window.addEventListener('beforeinstallprompt', this.beforeInstallPromptHandler);

    // --- Lógica original ---
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    const dominioParam = params.get('dominio');
    let id_dominio_backend = false;
    if (dominioParam) {
      try {
        const decodedDominio = atob(dominioParam);
        this.setState({ dominio: decodedDominio });
        window.localStorage.setItem('ari_app_dominio', decodedDominio);
        id_dominio_backend = true;
      } catch (e) {
        // handle invalid base64
        this.setState({ dominio: '' });
      }
    }
    localStorage.removeItem('ari_app_new_login');
    let data_login = getLoginApp();
    let dominio = getDominio();
    let save_data: any = getchek();
    this.setState({
      username: data_login && data_login.username ? data_login.username : "",
      password: data_login && data_login.password ? data_login.password : '',
      dominio: dominio && dominio != "false" ? dominio : '',
      simpleToast: false,
      loading: false,
      eye: true,
      save_data: save_data,
      response: {
        Msg: ""
      },
      id_dominio_backend: id_dominio_backend
    });
  }

  componentWillUnmount() {
    window.removeEventListener('beforeinstallprompt', this.beforeInstallPromptHandler);
  }

  beforeInstallPromptHandler: any;

  async handleInstallClick() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        this.setState({ showInstall: false });
      }
      this.deferredPrompt = null;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.setState({
      loading: nextProps.data.loading,
      simpleToast: nextProps.data.simpleToast,
      response: nextProps.data.response,

    });
  }
  handleChange(event: any) {

    if (event.target.name == "username") {
      this.setState({ username: event.target.value });
    } else if (event.target.name == "password") {
      this.setState({ password: event.target.value });
    } else if (event.target.name == "save_data") {
      this.setState({ save_data: event.target.checked });
      if (!event.target.checked) {
        window.localStorage.removeItem('data_login_ari_app');
        window.localStorage.removeItem('ari_chek');

      } else {
        window.localStorage.setItem('ari_chek', 'true');
      }
    } else if (event.target.name == "dominio") {
      console.log(event.target.value, event.target.name);
      if (event.target.value == "") {
        window.localStorage.setItem('ari_app_dominio', 'false');
      } else {
        window.localStorage.setItem('ari_app_dominio', event.target.value);
      }
      this.setState({ dominio: event.target.value });
    }
  }
  showPassword() {
    this.setState({ eye: !this.state.eye });
  }

  send() {
    let dataerrors: any = {};
    let validation_fields = false;

    if (!this.state.username) { dataerrors["username"] = ["*Campo requerido"]; validation_fields = true; };
    if (!this.state.password) { dataerrors["password"] = ["*Campo requerido"]; validation_fields = true; };
    if (!this.state.dominio) { dataerrors["dominio"] = ["*Campo requerido"]; validation_fields = true; };

    if (!validation_fields) {
      let data_login = getLoginApp();
      /*if (data_login) {
        if (this.state.username == data_login.username && this.state.password == data_login.password) {

          data_login.dominio = this.state.dominio;
          window.localStorage.setItem('data_login_ari_app', JSON.stringify(data_login));
          window.localStorage.setItem('islogued', 'true');
          window.location.href = baseurl() + "/home";

        } else {
          this.props.setData_({ response: { Msg: "Acceso denegado verifique su usuario y contraseña" }, simpleToast: true, loading: false });
        }
      } else {
        this.props.setData_({ loading: true });
        this.props.post_({ username: this.state.username, password: this.state.password, dominio: this.state.dominio, typeOption: 'login' }, "api/login");
      }*/
      this.props.setData_({ loading: true });
      console.log("enviando", { username: this.state.username, password: this.state.password, dominio: this.state.dominio, typeOption: 'login' });
      window.localStorage.setItem('ari_app_dominio', this.state.dominio);

      this.props.post_({ username: this.state.username, password: this.state.password, dominio: this.state.dominio, typeOption: 'login' }, "api/login");
    } else {
      this.props.setData_({ response: { Msg: "llenar campos" }, simpleToast: true, loading: false });
    }
  }
  onDidDismissToast(e: any) {
    this.props.setData_({ response: {}, simpleToast: false });
  }
  handleRefresh(event: any) {
    setTimeout(() => {
      event.detail.complete();
    }, 2000);
    window.location.reload();
  }

  printTransaction(e: any) {
    if (Capacitor.isNativePlatform()) {
      Printer.print({ content: '123', name: 'lorem-filename', orientation: 'portrait' })
        .then((res: any) => {
          console.log(res);
          this.props.setData_({ response: {}, simpleToast: false });
        })
        .catch((err: any) => {
          console.error(err);
          this.props.setData_({ response: { Msg: "Error al imprimir", success: false }, simpleToast: true });
        });
    } else {

      // Para navegador web
      const printFrame = document.createElement('iframe');
      printFrame.style.position = 'fixed';
      printFrame.style.right = '0';
      printFrame.style.bottom = '0';
      printFrame.style.width = '0';
      printFrame.style.height = '0';
      printFrame.style.border = '0';
      printFrame.srcdoc = '123';
      // Insertar el iframe en el div print-area en lugar de document.body
      const printArea = document.getElementById('print-area');
      if (printArea) {
        printArea.appendChild(printFrame);
      } else {
        document.body.appendChild(printFrame);
      }

      printFrame.onload = () => {
        printFrame.contentWindow?.focus();
        printFrame.contentWindow?.print();
        setTimeout(() => {
          if (printFrame.parentNode === document.body) {
            document.body.removeChild(printFrame);
          } else if (printFrame.parentNode) {
            printFrame.parentNode.removeChild(printFrame);
          }
        }, 3000);
      };

      this.props.setData_({ response: { Msg: "Error al imprimir 22", success: false }, simpleToast: true });
    }
  }

  render() {
    const { username, password, dominio, formErrors, eye, simpleToast, response, save_data, check, lat, id_dominio_backend, showInstall } = this.state;
    return (
      <IonPage>

        <div id="print-area" className="print-area" style={{ display: 'none', width: 0, height: 0, border: 'none' }} title="Print Area"></div>

        <IonContent fullscreen className="no-print" >
          <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
          <IonRow class="ion-padding-top">
            <IonCol className="ion-align-self-start" size="2"></IonCol>
            <IonCol className="ion-align-self-center" style={{ textAlign: 'center' }}>
              <img style={{ textAlign: 'center', width: "100%" }} src={'assets/img/logo.png'} />
            </IonCol>
            <IonCol className="ion-align-self-end" size="2"></IonCol>
          </IonRow>
          <form>
            <IonToast
              isOpen={simpleToast}
              message={`${response && response.Msg}`}
              duration={1500}
              onDidDismiss={e => this.onDidDismissToast(e)}
            />

            <IonRow>
              <IonCol col-12 size="12" style={{ display: 'flex', justifyContent: 'center' }}>
                <IonButton color="primary" onClick={this.handleInstallClick} style={{ marginTop: 16 }}>
                  <IonIcon slot="start" icon={downloadOutline} />
                  Descargar Ari-App
                </IonButton>
              </IonCol>
              <IonCol col-12 size="12">
                <IonItem>
                  <IonLabel position="stacked">Usuario: <IonText color="danger">*</IonText></IonLabel>
                  <IonInput name="username" required type="text" onIonChange={this.handleChange.bind(this)} value={this.state.username || ""}></IonInput>
                </IonItem>
                {formErrors && formErrors.username && (
                  <IonText color="danger" className="ion-padding-start">
                    <small>{formErrors.username}</small>
                  </IonText>
                )}
                <IonItem>
                  <IonLabel position="stacked">Contraseña: <IonText color="danger">*</IonText></IonLabel>
                  <IonInput name="password" required type={eye ? "password" : "text"} onIonChange={this.handleChange.bind(this)} value={this.state.password || ""}></IonInput>
                  <IonIcon icon={eye ? eyeOffOutline : eyeOutline} slot="end" onClick={this.showPassword.bind(this)}></IonIcon>
                </IonItem>
                {formErrors && formErrors.password && (
                  <IonText color="danger" className="ion-padding-start">
                    <small>{formErrors.password}</small>
                  </IonText>
                )}

                <IonItem style={{ display: id_dominio_backend ? 'none !important' : 'block !important' }}>
                  <IonLabel position="stacked">Dominio: <IonText color="danger">*</IonText></IonLabel>
                  <IonInput name="dominio" required type="text" onIonChange={this.handleChange.bind(this)} value={this.state.dominio || ""}></IonInput>
                </IonItem>
                {formErrors && formErrors.dominio && (
                  <IonText color="danger" className="ion-padding-start" style={{ display: id_dominio_backend ? 'block' : 'none' }}>
                    <small>{formErrors.dominio}</small>
                  </IonText>
                )}
                <div style={{ paddingLeft: '5%', paddingTop: '5%' }}></div>
                {formErrors && formErrors.dominio && (
                  <IonText color="danger" className="ion-padding-start" style={{ display: id_dominio_backend ? 'block' : 'none' }}>
                    <small>{formErrors.dominio}</small>
                  </IonText>
                )}
                <div style={{ paddingLeft: '5%', paddingTop: '5%' }}>
                  <IonCheckbox checked={save_data} name="save_data" onIonChange={this.handleChange.bind(this)}></IonCheckbox>&nbsp;&nbsp;&nbsp;
                  <IonLabel position="stacked">Recordar datos de acceso</IonLabel>
                </div>
              </IonCol>
            </IonRow>
            <div className="ion-padding">
              <IonButton onClick={this.send.bind(this)} disabled={false} expand="block" className="ion-no-margin">Ingresar</IonButton>
            </div>
          </form>
        </IonContent>
      </IonPage >
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    _get: PropTypes.func.isRequired,
    _post: PropTypes.func.isRequired,
    data: state.data,
    changeFields: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    catalogue: state.catalogue,
    setData_: PropTypes.func.isRequired,

  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    post_: (fields: any, controller: string) => dispatch(HomeActions.post_(fields, controller)),
    setData_: (data: any, name: string) => dispatch(HomeActions.setData(data, name)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
